import type { TranslationMessages } from '../../types';

export const common: TranslationMessages = {
  member: 'staff member',
  members: 'staff members',
  items_per_page: 'Items per page',
  first_page: 'First page',
  last_page: 'Last page',
  next_page: 'Next page',
  previous_page: 'Previous page',
  visible_after_filter: 'visible after role filter',
};
